<template>
  <teleport to="#drawerFormTeleportDestination" v-if="drawerInfo?.isDrawerRendered === true">
    <slot v-bind:id="drawerInfo.id"></slot>
  </teleport>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useCoreStore } from '../../stores/core/store';

const { drawerInfo } = storeToRefs(useCoreStore());
</script>
